import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Theme slice
export type ThemeMode = 'light' | 'dark';
export interface ThemeState { mode: ThemeMode }
const themeInitialState: ThemeState = { mode: 'dark' };

export const themeSlice = createSlice({
    name: 'theme',
    initialState: themeInitialState,
    reducers: {
        setTheme(state, action: PayloadAction<ThemeMode>) { state.mode = action.payload },
        toggleTheme(state) { state.mode = state.mode === 'dark' ? 'light' : 'dark' },
    },
});
export const { setTheme, toggleTheme } = themeSlice.actions;

// User slice
export interface AppUser {
    uid: string;
    email: string | null;
    displayName?: string | null;
    photoURL?: string | null;
}
export interface BankInfo {
    userId: string;
    companyId: string;
    companyName: string;
    companyNo: string;
    companyAddress: string;
    email: string;
    imgUrl?: string;
    createdAt?: number; // millis since epoch
}

export interface PsoInfo {
    authUid: string;
    name: string;
    email: string;
    contact?: string;
    designation?: string;
    createdAt?: number; // millis since epoch
}

interface UserState {
    currentUser: AppUser | null;
    bank: BankInfo | null;
    pso: PsoInfo | null;
}
const userInitialState: UserState = { currentUser: null, bank: null, pso: null };

export const userSlice = createSlice({
    name: 'user',
    initialState: userInitialState,
    reducers: {
        setUser(state, action: PayloadAction<AppUser | null>) { state.currentUser = action.payload },
        setBank(state, action: PayloadAction<BankInfo | null>) { state.bank = action.payload },
        setPso(state, action: PayloadAction<PsoInfo | null>) { state.pso = action.payload },
    },
});
export const { setUser, setBank, setPso } = userSlice.actions;




